// Polarity helpers — цвет значения параметра.

/** Цвет значения: emerald (сильно), rose (слабо), amber (норма) */
export function scoreColor(value: number, _key?: string): string {
  if (value >= 66) return 'text-emerald-600';
  if (value <= 40) return 'text-rose-600';
  return 'text-amber-600';
}

/** Класс фонового цвета для полос */
export function scoreBg(value: number, _key?: string): string {
  if (value >= 66) return 'bg-emerald-500';
  if (value <= 40) return 'bg-rose-500';
  return 'bg-amber-500';
}
